import styled from 'styled-components'

export const GridMain = styled.main<{
    colorGuide: boolean
}>`
    grid-area: main;
    background-color: ${({ colorGuide }) => (colorGuide ? '#F1F3FB' : 'none')};
    max-width: 100vw;
`
